import { adminHttpClient } from '../../../commons/adminHttpClient'
import localStorage from '../../../commons/localStorage'

const question4Api = (coverageOptionsImportance: number): Promise<any> => {
  const code = localStorage.getProspectSignupCode()

  return adminHttpClient.put('/IchraDecisionTool/ProspectApplication/Step2/Question4', {
    coverageOptionsImportance: coverageOptionsImportance,
    token: code,
  })
}

export default question4Api
